var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel2RectElecColleague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patt1",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y: 0,
    x2: 0,
    y2: 24,
    stroke: "#d32f2f",
    strokeWidth: 28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 200,
    x: 0,
    y: 0,
    fill: "#d2dae1",
    stroke: "#75baff",
    strokeWidth: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 196,
    x: 2,
    y: 2,
    stroke: "#d2dae1",
    fill: "url(#patt1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel2RectElecColleague);
export default __webpack_public_path__ + "static/media/place_model-2_rect_elec_colleague.6d2fe77b2368b7bda2840545d54e04b7.svg";
export { ForwardRef as ReactComponent };